import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { getformatDate, getformatTime } from "../../../../JsHelpers/DateFormat";
import { Icon } from "leaflet";
import { Marker, useMap } from "react-leaflet";
import trans from "../../../../utils";

export default function PlayBackEvents({ events, data }) {
	const [geoCodes, setGeoCode] = useState({});
	const [selectedRow, setSelectedRow] = useState(null);
	const fetchMultipleGeoCodePosition = async (lat, lon, id, type) => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
			);

			setGeoCode((prev) => ({
				...prev,
				[id]: {
					...prev[id],
					[type]: response.data.display_name,
				},
			}));
		} catch (error) {
			toast.error(trans("Error fetching geocode position:"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};

	const eventImg = (type) => {
		if (type === "ignitionOff") {
			return "Ignitionoff";
		} else if (type === "ignitionOn") {
			return "Ignitionon";
		} else if (type === "deviceOverspeed") {
			return "Overspeed";
		} else if (type === "geofenceEnter") {
			return "GeoEnter";
		} else if (type === "geofenceExit") {
			return "GeoExit";
		} else if (type === "deviceFuelIncrease") {
			return "Fuelincrease";
		} else if (type === "deviceFuelDrop") {
			return "Fueldrop";
		} else if (type === "deviceMoving") {
			return "VehicleMoving";
		} else if (type === "deviceStopped") {
			return "Devicestopped";
		} else if (type === "deviceUnknown") {
			return "Deviceunknown";
		} else if (type === "deviceOnline") {
			return "Deviceonline";
		} else if (type === "deviceOffline") {
			return "Deviceoffline";
		} else if (type === "idle") {
			return "Idle";
		}
	};
	let getAlertType = (type) => {
		if (type === "deviceOverspeed") {
			return "Speed Alert";
		} else if (type === "geofenceExit") {
			return "Geofence exited";
		} else if (type === "geofenceEnter") {
			return "Geofence entered";
		} else if (type === "deviceFuelDrop") {
			return "Fuel drop";
		} else if (type === "deviceFuelIncrease") {
			return "Fuel increase";
		} else if (type === "idle") {
			return "Vehicle Idle";
		} else {
			return type;
		}
	};
	const truncateItem = (text) => {
		const maxLength = 45;
		return text?.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};
	const map = useMap();
	return (
		<>
			<div className="history-playback-trip-events">
				<div className="trip-events">
					{events?.length > 0 ? (
						<>
							{events?.map((event, index) => {
								const matchedItem = data.find(
									(item) => item.id === event.positionId
								);

								if (matchedItem) {
									const { latitude, longitude } = matchedItem;
									const eventIcon = new Icon({
										iconUrl: `${process.env.PUBLIC_URL}/assets/${eventImg(
											event.type
										)}.svg`,
										iconSize: [20, 20],
									});
									return (
										<div key={event.positionId}>
											<div
												className={`${
													selectedRow === index
														? "trip-events-container-active"
														: "trip-events-container"
												}`}
												onClick={() => {
													setSelectedRow(index === selectedRow ? null : index);
													map.setView([latitude, longitude]);
												}}
											>
												<div key={event.positionId} className="mb-3  by-15">
													<div className="flex-between">
														<div className="flex-between">
															<div className="table-checkbox">
																<input
																	type="checkbox"
																	onChange={() => {}}
																	name=""
																	id=""
																	checked={selectedRow === index}
																	readOnly
																/>
															</div>
															<div>
																<div className="event-name">
																	{trans(getAlertType(event.type))}
																</div>
																<div
																	className="address text-primary my-1"
																	title={geoCodes[index]?.start}
																	onClick={() =>
																		fetchMultipleGeoCodePosition(
																			latitude,
																			longitude,
																			index,
																			"start"
																		)
																	}
																>
																	{geoCodes[index]?.start
																		? truncateItem(geoCodes[index]?.start)
																		: trans("Get current address")}
																</div>
																<div className="date">
																	{getformatTime(event.eventTime)}{" "}
																	{getformatDate(event.eventTime)}
																</div>
															</div>
														</div>
														<div className="me-2">
															<img
																src={`${
																	process.env.PUBLIC_URL
																}/assets/New/Alerts/${eventImg(
																	event.type
																)}.svg`}
																alt="event"
															/>
														</div>
													</div>
												</div>
											</div>
											<div className="H-line"></div>
										</div>
									);
								}
								return null;
							})}
						</>
					) : (
						<>
							<div className="my-5 p-5">
								<div className="text-center text-success fs-16 fw-700">
									No Events Shown
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
}
